exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-autocomplete{width:100%}.el-autocomplete .el-input__inner{border:none}.edit_icon:hover{opacity:.7}", "", {"version":3,"sources":["/home/webuser/baxiclub/releases/24/spa/src/pages/sales/tradeOrganization/TradeOrganization.vue"],"names":[],"mappings":"AAEA,iBACE,UAAA,CAEA,kCACE,WAAA,CAIJ,iBACE,UAAA,CAAA","file":"TradeOrganization.vue?vue&type=style&index=0&id=2f811e8e&prod&lang=scss","sourcesContent":["\n\n.el-autocomplete {\n  width: 100%;\n\n  .el-input__inner {\n    border: none;\n  }\n}\n\n.edit_icon:hover {\n  opacity: 0.7;\n}\n\n"],"sourceRoot":""}]);

// exports
